module.exports = __webpack_public_path__ + "img/46.4e2f101d.jpg";